import { useState } from "react";

const MyNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="prabesh">PRASOON</div>

        {/* Desktop Links */}
        <div className="nav-links">
          <a href="#about" className="lin">
            About
          </a>
          <a href="#github" className="lin">
            GitHub
          </a>
          <a href="#projects" className="lin">
            Projects
          </a>
          <a href="#skills" className="lin">
            Skills
          </a>
          <a href="#contact" className="lin">
            Contact Me
          </a>
        </div>

        {/* Hamburger (Mobile) */}
        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
      </nav>

      {/* Mobile Popup Menu */}
      {isOpen && (
        <div className="popup-menu">
          <a href="#about" className="lin">
            About
          </a>
          <a href="#github" className="lin">
            GitHub
          </a>
          <a href="#projects" className="lin">
            Projects
          </a>
          <a href="#skills" className="lin">
            Skills
          </a>
          <a href="#contact" className="lin">
            Contact Me
          </a>
        </div>
      )}
    </>
  );
};

export default MyNav;
